export const testimonials = [
  {
    id: 't1',
    name: 'Familia Ramírez',
    event: 'XV de Fernanda · CDMX',
    quote:
      'En MisXV.com.mx encontramos el salón, la barra de postres y el fotógrafo en la misma tarde. Comparar cotizaciones nos ahorró tiempo y dinero.',
    avatarSeed: 'testi1',
  },
  {
    id: 't2',
    name: 'Familia Torres',
    event: 'XV de Ximena · Guadalajara',
    quote:
      'La academia de baile que contactamos por la plataforma fue increíble, y pudimos leer reseñas reales de otras mamás antes de decidir.',
    avatarSeed: 'testi2',
  },
  {
    id: 't3',
    name: 'Familia Hernández',
    event: 'XV de Camila · Monterrey',
    quote:
      'Nos encantó poder guardar nuestros proveedores favoritos y pedir cotización a varios al mismo tiempo desde el celular.',
    avatarSeed: 'testi3',
  },
];
